import axios from "axios";
import { useDialogStore } from "@/store/dialog";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const http = axios.create({
  baseURL: API_URL + "/admin/",
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
})

http.interceptors.response.use(
    response => response,

    error => {
        if (error.response?.status === 403) {
            const dialog = useDialogStore()

            dialog.open(
                'Access Denied',
                error.response.data.message || 'You do not have permission to access this page.'
            )

            // return Promise.resolve({
            //     data: null,
            //     handled: true
            // })
        }

        return Promise.reject(error)
    }
)

export const STORAGE_URL = process.env.VUE_APP_STORAGE_URL;
export default http;